import { useGetSlakterierQuery } from 'prove-common'
import { ALL_FILTER_VALUE } from '../components/statistics/statisticsFilterUtils'
import type { FilterOption } from '../components/statistics/statisticsTypes'

export const useEftaNumberOptions = (
  options: FilterOption[],
  enabled: boolean
): FilterOption[] => {
  const eftanummer = options
    .filter((option) => option.value !== ALL_FILTER_VALUE)
    .map((option) => option.value)
  const { data: slakterier = [] } = useGetSlakterierQuery(eftanummer, enabled)
  const namesByEftanummer = new Map<string, string>(
    slakterier.map(({ eftanummer, navn }) => [eftanummer, navn])
  )

  return options.map((option) => {
    const name = namesByEftanummer.get(option.value)
    return name
      ? { ...option, label: name.concat(' (', option.value, ')') }
      : option
  })
}
